import { Wrapper } from '@farewill/ui'
import styled from 'styled-components'
import { COLOR, FONT } from '@farewill/ui/tokens'
import { smallCaps } from '@farewill/ui/helpers/text'

const BRAND_STYLES = {
  Farewill: {
    text: 'Farewill',
    backgroundColor: COLOR.ACCENT.PRIMARY,
    textColor: '#000000',
    iconPath: '/images/farewill-logo.svg',
  },
  Dignity: {
    text: 'Dignity Legal Services',
    backgroundColor: '#07265c',
    textColor: '#ffffff',
    iconPath: '/images/dignity-legal-services-logo.svg',
  },
  Simplicity: {
    text: 'Simplicity Cremations',
    backgroundColor: '#ee7518',
    textColor: '#ffffff',
    iconPath: '/images/simplicity-cremations-logo.svg',
  },
  Unknown: {
    text: 'Unknown',
    backgroundColor: '#7c7c7c',
    textColor: '#ffffff',
    iconPath: '',
  },
} as const

const StyledWrapper = styled(Wrapper)<{
  $textColor: string
}>`
  padding: 6px 12px;
  border-radius: 20px;
  color: ${({ $textColor }) => $textColor};
  display: inline-flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  font-family: ${FONT.FAMILY.BODY};
  white-space: nowrap;
  ${smallCaps}
  font-size: ${FONT.SIZE.S};
  margin-bottom: 0;
`

export interface BrandProps {
  brand: string
}

export const BrandIndicator = ({ brand, ...props }: BrandProps) => {
  const brandStyle =
    brand in BRAND_STYLES
      ? BRAND_STYLES[brand as keyof typeof BRAND_STYLES]
      : BRAND_STYLES['Unknown']
  return (
    <>
      <StyledWrapper
        background={brandStyle.backgroundColor}
        $textColor={brandStyle.textColor}
        {...props}
      >
        {brandStyle.iconPath && (
          <img src={brandStyle.iconPath} alt={brandStyle.text} />
        )}
        {brandStyle.text}
      </StyledWrapper>
    </>
  )
}
